import { useTranslation } from 'react-i18next';
import { FilesContainer } from 'modules/files';
import type { LeadCloudFileType } from '@econtractor/types';

interface TaskCardFilesProps {
    taskId: number;
    files: LeadCloudFileType[];
    canEdit?: boolean;
    onFilesChange?: (nextFiles: LeadCloudFileType[]) => Promise<boolean>;
}

const TaskCardFiles = ({ taskId, files, canEdit = false, onFilesChange }: TaskCardFilesProps) => {
    const { t } = useTranslation(['Tasks', 'FileNavigator', 'common']);
    const list = Array.isArray(files) ? files : [];
    if (!canEdit && !list.length) return null;

    return (
        <FilesContainer
            files={list}
            scope={{ taskId: Number(taskId || 0) }}
            imageColProps={{ xs: 6, md: 4 }}
            canEdit={canEdit}
            addButtonLabel={t('btnAttach')}
            uploadingLabel={t('common:buttons.uploading')}
            saveFirstMessage=""
            errorMessage={t('common:messError')}
            uploadSuccessMessage={t('FileNavigator:messDownloadSuccess')}
            onFilesChange={onFilesChange ?? (async () => true)}
        />
    );
};

export default TaskCardFiles;
